// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import CategoriesGql from '@/store/graphql/cms/queries/Categories.gql';
import CreateCategoryGql from '@/store/graphql/cms/mutations/CreateCategory.gql';
import _ from 'lodash';

export default {
    fetchList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: CategoriesGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_Categories))
                .catch(err => reject(err));
        }),
    create: category => {
        if (category === undefined) throw new Error('required argument is missing');

        category = _.removeDeepByKey(category, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateCategoryGql,
                    variables: { category }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CP_CreateCategory);
                })
                .catch(err => reject(err));
        });
    }
};
